import { getZonedDate } from '@eika-infrastruktur/date';
import nullableZonedDateToUtc from '../../../../utils/mapper/nullableZonedDateToUtc';
export default (state) => {
    const paymentDate = state.paymentDate ?? getZonedDate();
    const getKid = () => {
        if (state.immediate || !state.toAccount?.kidFormats?.length)
            return undefined;
        if (state.kid?.value)
            return state.kid;
        return undefined;
    };
    const kid = getKid();
    const text = kid ? undefined : state.note;
    const request = {
        fromAccountNumber: state.fromAccount,
        toAccount: state.toAccount.accountNumber,
        toAccountName: state.toAccount.accountName,
        amount: state.amount,
        currency: 'NOK',
        kid,
        text,
        paymentDate: nullableZonedDateToUtc(paymentDate),
        receiptType: state.receiptType,
        ownText: state.ownText,
        immediate: state.immediate,
        deviceId: window.ReactNativeProps?.deviceId,
    };
    return {
        paymentRequest: request,
        acceptDuplicate: true,
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlT3V0Ym94UmVxdWVzdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3RyYW5zYWN0aW9uL1BheW1lbnQvZm9ybS9jcmVhdGVPdXRib3hSZXF1ZXN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSwwQkFBMEIsQ0FBQztBQUl4RCxPQUFPLHNCQUFzQixNQUFNLGlEQUFpRCxDQUFDO0FBR3JGLGVBQWUsQ0FBQyxLQUFtQixFQUF1QixFQUFFO0lBQ3hELE1BQU0sV0FBVyxHQUFHLEtBQUssQ0FBQyxXQUFXLElBQUksWUFBWSxFQUFFLENBQUM7SUFDeEQsTUFBTSxNQUFNLEdBQUcsR0FBRyxFQUFFO1FBQ2hCLElBQUksS0FBSyxDQUFDLFNBQVMsSUFBSSxDQUFDLEtBQUssQ0FBQyxTQUFTLEVBQUUsVUFBVSxFQUFFLE1BQU07WUFBRSxPQUFPLFNBQVMsQ0FBQztRQUM5RSxJQUFJLEtBQUssQ0FBQyxHQUFHLEVBQUUsS0FBSztZQUFFLE9BQU8sS0FBSyxDQUFDLEdBQUcsQ0FBQztRQUN2QyxPQUFPLFNBQVMsQ0FBQztJQUNyQixDQUFDLENBQUM7SUFFRixNQUFNLEdBQUcsR0FBRyxNQUFNLEVBQUUsQ0FBQztJQUNyQixNQUFNLElBQUksR0FBRyxHQUFHLENBQUMsQ0FBQyxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQztJQUUxQyxNQUFNLE9BQU8sR0FBbUI7UUFDNUIsaUJBQWlCLEVBQUUsS0FBSyxDQUFDLFdBQVk7UUFDckMsU0FBUyxFQUFFLEtBQUssQ0FBQyxTQUFVLENBQUMsYUFBYTtRQUN6QyxhQUFhLEVBQUUsS0FBSyxDQUFDLFNBQVUsQ0FBQyxXQUFXO1FBQzNDLE1BQU0sRUFBRSxLQUFLLENBQUMsTUFBTztRQUNyQixRQUFRLEVBQUUsS0FBSztRQUNmLEdBQUc7UUFDSCxJQUFJO1FBQ0osV0FBVyxFQUFFLHNCQUFzQixDQUFDLFdBQVcsQ0FBRTtRQUNqRCxXQUFXLEVBQUUsS0FBSyxDQUFDLFdBQVc7UUFDOUIsT0FBTyxFQUFFLEtBQUssQ0FBQyxPQUFPO1FBQ3RCLFNBQVMsRUFBRSxLQUFLLENBQUMsU0FBUztRQUMxQixRQUFRLEVBQUUsTUFBTSxDQUFDLGdCQUFnQixFQUFFLFFBQVE7S0FDOUMsQ0FBQztJQUNGLE9BQU87UUFDSCxjQUFjLEVBQUUsT0FBTztRQUN2QixlQUFlLEVBQUUsSUFBSTtLQUN4QixDQUFDO0FBQ04sQ0FBQyxDQUFDIn0=